import styled from 'styled-components';

import Modal from 'components/ui/Modal';
import { Row } from 'components/shared/Layout';
import { ModalContainer } from 'components/ui/Modal/Modal.styles';

export const SearchContainer = styled(Row)`
  position: relative;
  left: ${(props) => (props.show ? '0%' : '105%')};
  transition: left 0.75s;
  margin-left: 16px;
`;

export const StyledModal = styled(Modal)`
  padding: 0 200px;
  box-sizing: border-box;

  ${ModalContainer} {
    height: 750px;
  }
`;
